module.exports = __webpack_public_path__ + "img/flag-jp.ec2bef71.svg";